import { css } from '@emotion/css';
import { AlignItems, Color, Display, Font, FontWeight, JustifyContent, ScreenBreakpoint, Spacing } from 'src/styles';

export const mobileUserInfoWrapper = css`
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 24px;
`;

// AccountValue component
export const accountValueContainer = css`
  ${Font.h6}
`;

export const accountValue = css`
  ${FontWeight.semibold}
  color: ${Color.Green7};
`;

export const accountLabel = css`
  ${FontWeight.semibold}
  color: ${Color.Gray7};
`;

// AccountHolderFullName component
export const fullName = css`
  ${Font.h6}
  ${FontWeight.semibold}
`;

export const accountType = css`
  ${Font.md}
  color: ${Color.Gray8};
`;

// UserInfo
export const iconContainer = css`
  width: 32px;
  height: 32px;
  ${Display.inlineFlex}
  ${AlignItems.center}
  ${JustifyContent.center}
  ${FontWeight.normal}

  .anticon {
    ${Display.flex}
    line-height: 0 !important;
  }
`;

export const menuSubtitle = css`
  ${Spacing.py8}
  && {
    ${Spacing.pl8}
    ${Spacing.mb8}
  }

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    && {
      ${Spacing.pl0}
    }
  }
`;
